(function () {
  document.addEventListener('algolia.hooks.initialize', function () {
    // Get translations from Liquid-generated object
    var t = window.theme && window.theme.translations && window.theme.translations.search || {};
    
    algoliaShopify.hooks.registerHook('beforeInstantSearchConfigurationOptions', function (options) {
      algoliaShopify.translations = {
        facets: null,
        addToCart: t.addToCart || 'Add to cart',
        allProducts: t.allProducts || 'All products',
        articles: t.articles || 'Articles',
        by: t.by || 'by',
        changeInput: t.changeInput || 'changing your search',
        clearAll: t.clearAll || 'Clear Search',
        clearFilters: t.clearFilters || 'Reset filters',
        collections: t.collections || 'Collections',
        in: t.in || 'in',
        matching: t.matching || 'matching',
        noResultFor: t.noResultFor || 'No results for ',
        noResultFound: t.noResultFound || 'No results found',
        oneResultFound: t.oneResultFound || 'One result found',
        or: t.or || 'or',
        outOf: t.outOf || 'of',
        outOfStock: t.outOfStock || 'Sold out',
        pages: t.pages || 'Pages',
        products: t.products || 'Products',
        relevance: t.relevance || 'Relevance',
        resultsFound: t.resultsFound || 'results found',
        search: t.search || 'Active search',
        searchForProduct: t.searchForProduct || 'Search products',
        searchTitle: t.searchTitle || 'Search',
        selectedFilter: t.selectedFilter || 'Active Filters',
        showLess: t.showLess || 'Show less',
        showMore: t.showMore || 'Show more',
        sortBy: t.sortBy || 'Sort by',
        sort_orders: t.sortOrders || 'order',
        suggestions: t.suggestions || 'Suggestions',
        taxFree: t.taxFree || 'Tax free',
        try: t.try || 'Try'
      };
      options.numberLocale = window.theme && window.theme.locale || 'it';
      return options;

    });
    algoliaShopify.hooks.registerHook('beforeInstantSearchOptions', function (options) {
      return options;

    });
    algoliaShopify.hooks.registerHook('beforeInstantSearchMainTemplate', function (defaultTemplate, data, html) {
      var t = window.theme && window.theme.translations && window.theme.translations.search || {};
      return html`
      <div class="ais-page">
        <h1 class="ais-h2">${t.title || 'SEARCH'}</h1>
        <div class="ais-input">
          <div class="ais-search-box-container"></div>
          <div class="ais-input-button">
            <div class="ais-clear-input-icon"></div>
          </div>
        </div>
        <div class="ais-facets-button">
          ${t.showFilters || 'Show filters'}
        </div>
        <div class="ais-facets">
          <div class="ais-clear-refinements-container"></div>
          <div class="ais-current-refined-values-container"></div>
          ${data.facets.map(
        facet =>
          html`
                <div
                  class="ais-facet-dropdown-wrapper ais-facet-${facet.type} ais-facet-${facet.escapedName}"
                >
                  <label
                    for="${facet.escapedName}"
                    class="ais-range-slider--header ais-facet--header ais-header"
                    >${facet.title}</label
                  >
                  <input
                    class="ais-dropdown-checkbox"
                    type="checkbox"
                    id="${facet.escapedName}"
                    name="dropdown"
                  />
                  <div
                    class="ais-facet-${facet.escapedName}-container ais-facet-dropdown-container"
                  ></div>
                </div>
              `
      )}
        </div>
        <div class="ais-block">
          <div class="ais-search-header">
            <div class="ais-stats-container"></div>
            <div class="ais-change-display" style="display:none">
              <span class="ais-change-display-block ais-change-display-selected"><i class="fa fa-th-large"></i></span>
              <span class="ais-change-display-list"><i class="fa fa-th-list"></i
              ></span>
            </div>
            <div class="ais-sort">
              ${data.multipleSortOrders
          ? html`
                    ${algoliaShopify.translations.sortBy}
                    <span class="ais-sort-orders-container"></span>
                  `
          : html`
                    ${algoliaShopify.translations.sortBy}
                    ${algoliaShopify.translations.relevance}
                  `}
            </div>
          </div>
          <div class="ais-hits-container ais-results-as-block"></div>
        </div>
        <div class="ais-pagination-container"></div>
      </div>`;
    });

    // beforeInstantSearchProductTemplate(defaultTemplate, data, html, components)
    algoliaShopify.hooks.registerHook('beforeInstantSearchProductTemplate', function (defaultTemplate, hit, html, components) {
      const discountedPrice = (hit.compare_at_price > hit.price) && `<del>${algoliaShopify.helpers.displayStrikedPrice(hit.price, hit.compare_at_price).replace("$", "€")}</del>` || '';
      const discount = (hit.compare_at_price > hit.price) && `<span class="discount">${algoliaShopify.helpers.displayDiscount(hit.price, hit.compare_at_price, hit.price_ratio).replaceAll(' ', '').replace("$", "€")}</span>` || '';
      const price = algoliaShopify.helpers.displayPrice(hit, hit._distinct).replace("$", "€");
      const title = hit.title.replace(hit.option1, '').replace(" - ", "");
      const details =
        `<div class="details">
          <div class="priceBuy">
            ${discountedPrice}
            <h4 class="price">${price}</h4>
            ${discount}
          </div>
          <h2>
            <span>${hit.vendor} ${title}</span>
            <span>${hit.option1}</span>
          </h2>
        </div>`;

      const content =
        `<a
          class="product productMiniature"
          data-algolia-index="${hit.index}"
          data-algolia-position="${hit.productPosition}"
          data-algolia-queryid="${hit.queryID}"
          data-algolia-objectid="${hit.objectID}"
          data-handle="${hit.handle}"
          data-variant-id="${hit.objectID}"
          data-distinct="${hit._distinct}"
          data-product-id="${hit.id}"
          href="${algoliaShopify.helpers.instantsearchLink(hit)}"
          title="${hit.vendor} ${hit.title}">
          <div class="imageWrap">
            <img
              class="productImage lazyload"
              loading="lazy"
              src="${algoliaShopify.helpers.smallImage(hit)}"
              data-src="${algoliaShopify.helpers.originalImage(hit)}"
            >
            <div class="wishMiniature" onclick="event.stopPropagation();event.preventDefault();">
        <div class="wishlistCollection"></div>
      </div>
          </div>
          ${details}
        </a>`;
      return html`${content}`;
    });
  });


})();
